export const DEFAULT_LIMIT_WORDS = 10;